import React, { useState, useEffect } from 'react';
import Styles from './App.module.scss';
import ArccosTile from './components/ArccosTile/ArccosTile';
import PlayerInsightsLandingPage from './pages/PlayerInsightsLandingPage/PlayerInsightsLandingPage';
import PlayerInsightSlideOutModal from './components/PlayerInsightSlideOutModal/PlayerInsightSlideOutModal';
import { LocalizationProvider } from './context/localizationContext';

function App(props) {
  const { organization } = props;
  const [isTileView, setTileView] = useState(true);
  const toggleModal = () => {
    setTileView(!isTileView);
  };

  useEffect(() => {
    localStorage.setItem('Organization', organization);
  }, []);

  return (
    <div className={Styles.App}>
      <LocalizationProvider>
        <ArccosTile isTileView={isTileView} toggleModal={toggleModal} />
        <PlayerInsightSlideOutModal
          isOpen={!isTileView}
          toggleModal={toggleModal}
        >
          <PlayerInsightsLandingPage toggleModal={toggleModal} />
        </PlayerInsightSlideOutModal>
      </LocalizationProvider>
    </div>
  );
}

export default App;
